import * as React from "react"
const SvgEmails = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 4.714a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1m0 2a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2z" />
    <path
      fillRule="evenodd"
      d="M3.587 21.127q.588.587 1.413.587h14q.824 0 1.413-.587A1.93 1.93 0 0 0 21 19.714v-8q0-.825-.587-1.412A1.93 1.93 0 0 0 19 9.714H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 11.714v8q0 .825.587 1.413M19 13.139l-6.09 3.11a2 2 0 0 1-1.82 0L5 13.14v6.575h14V13.14ZM6.45 11.714l5.55 2.55 5.5-2.55z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgEmails
